export function request( universe, token ) {
    return {
        type: 'UNIVERSE_SWITCH_REQUEST',
        universe,
        token
    };
}

export function error() {
    return {
        type: 'UNIVERSE_SWITCH_ERROR'
    };
}

export function finish() {
    return {
        type: 'UNIVERSE_SWITCH_FINISH'
    };
}
